export const TINY = 8
export const SMALL = TINY * 2
export const MEDIUM = TINY * 3
export const BIG = TINY * 4
export const LARGE = TINY * 5
export const LATERAL = 20
